import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { SlotInterface } from '../../components/book-appointment/book-appointment.component';

@Injectable({
    providedIn: 'root',
})
export class SlotService {
    constructor(private readonly  http: HttpClient) { }

    getSlotsByProviderId(referenceId: string, startDate: string, endDate: string): Observable<{ response: SlotInterface[] }> {
        return this.http.get<{ response: SlotInterface[] }>(`${environment.cva_url}${API_ROUTES.SLOT}?practitionerId=${referenceId}&start=${startDate}&end=${endDate}`);
    }
}
